import { FormDescription } from "@/components/ui/form";
import { languages } from "@/constants/languages";

interface LanguageSelectProps {
  value: string;
  onChange: (value: string) => void;
  description?: string;
  className?: string;
  id?: string;
  label?: string;
}

export default function LanguageSelect({
  value,
  onChange,
  description = "Choose the primary language for your brand content.",
  className = "",
  id = "language-select",
  label = "Language",
}: LanguageSelectProps) {
  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={`space-y-2 ${className}`}>
      <label
        htmlFor={id}
        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={handleLanguageChange}
        className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <option value="">Select a language...</option>
        {languages.map((language) => (
          <option key={language} value={language}>
            {language}
          </option>
        ))}
      </select>
      {description && (
        <FormDescription className="text-xs">{description}</FormDescription>
      )}
    </div>
  );
}
